import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./breadcrumb.css";

class BreadCrumpBack extends Component {
  handleBack = () => {
   window.history.go(-1);
  };

  render() {
    return (
      <div className="breadcrumb-wrapper2">
        <ol className="breadcrumb">
          <li className="breadcrumb-item selactive">
            <Link to={"/"}>Home</Link>
          </li>
          <li className="breadcrumb-item selactive">
            <Link to={"#"} onClick={this.handleBack}>
              Back
            </Link>
          </li>
        </ol>
      </div>
    );
  }
}

export default BreadCrumpBack;
